/* 
 * App Name: SDI-Walmart
 * Author: Dhevanesam R
 * Created Date: 12/11/2022
 * [12/15/22], PC_WW-552_FE_11 to 25, PC_WW-552_FE_28 and PC_WW-552_FE_46, Dhevanesam R
 */

import React, { Component } from 'react';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import ItemDetailNewStore from '../stores/ItemDetailNewStore';
import SearchResultsStore from '../stores/SearchResultsStore';
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
//WW-920_PC_
import * as SupplierSuggestionAction from '../actions/SupplierSuggestionAction';
import SupplierSuggestionStore from '../stores/SupplierSuggestionStore';
import * as ShoppingCartAction from '../actions/ShoppingCartAction';
import ShoppingCartStore from '../stores/ShoppingCartStore';
import swal from 'sweetalert';
import * as CookieService from '../CookieService';
import FormsPDFComponent from './FormsPDFComponent';
import { MapInteractionCSS } from 'react-map-interaction';
import { withTranslation, Trans } from 'react-i18next';
let buttonAction = "";
let existingPDF = [];
let proceedCart = false;

class FormsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FormData: this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.FormData : [],// WW-920_PC_17
            FormOptionsData: this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.FormOptionsData : [],
            FormName: this.props.location.state.FormName,
            attachmentPathArr: [],
            formAttachURL: "", formAttachLabel: "", formAttachDesc: "", FormList: this.props.location.state.pagename == "shoppingcart" ? this.props.location.state.FormList : [],
            allowOneUpload: [], uploadIndex: null, tempImageArr: [], uploadedByte: null, formArray: [], formIndex: 0, currentQty: 0,
            formDataTemp: this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.FormData : [],
            totalQty: this.props.location.state.pagename != "shoppingcart" ? this.props.location.state.qty : Number(this.props.location.state.FormList[0].Qty) - Number(this.props.location.state.FormList[0].RTI_QTY ? this.props.location.state.FormList[0].RTI_QTY: 0 ), formCount : 1
        }
        console.error("formcomponent", this.props.location.state.pagename)

        this.keyPress = this.keyPress.bind(this);
        this.AddtocartSuccess = this.AddtocartSuccess.bind(this);
        this.UpdateItemDesp_response = this.UpdateItemDesp_response.bind(this)
        this.DeleteItemFromCart_response = this.DeleteItemFromCart_response.bind(this)
    }
    componentDidMount() {
        window.scrollTo(0, 0)

        //WW-920_PC_16 -Aparna
        if (this.props.location.state.pagename != "shoppingcart") {
            this.optionsLoad()
        } if (this.props.location.state.pagename == "shoppingcart") {
            this.dynamicForms_API()
            // this.refs.fromText.value = '';
        }
        SupplierSuggestionStore.on('DynamicForm', this.dynamicForms_API_response);
        ItemDetailNewStore.on("addToCart", this.AddToCartResponse);
        NonCatalogStore.on('FormsattachmentResponse', this.loadAttachments);
        SearchResultsStore.on("Status", this.AddtocartSuccess);
        ShoppingCartStore.on("UpdateStatus", this.UpdateItemDesp_response);
        ShoppingCartStore.on("deleteItem", this.DeleteItemFromCart_response);
        NonCatalogStore.on('NONCAT_UploadAttachmentsForms', this.uploadImageResponse);
        NonCatalogStore.on('rmvAttachForms', this.removeAttachmentResponse);
        ShoppingCartStore.on('HostedSuccessfully', this.hostedResponse);
    }
    componentWillUnmount() {
        //WW-920_PC_17 -Aparna
        SupplierSuggestionStore.removeListener('DynamicForm', this.dynamicForms_API_response);
        ItemDetailNewStore.removeListener("addToCart", this.AddToCartResponse);
        SearchResultsStore.removeListener("Status", this.AddtocartSuccess);
        NonCatalogStore.removeListener('FormsattachmentResponse', this.loadAttachments);
        ShoppingCartStore.removeListener("UpdateStatus", this.UpdateItemDesp_response);
        ShoppingCartStore.removeListener("deleteItem", this.DeleteItemFromCart_response);
        NonCatalogStore.removeListener('NONCAT_UploadAttachmentsForms', this.uploadImageResponse);
        NonCatalogStore.removeListener('rmvAttachForms', this.removeAttachmentResponse);
        ShoppingCartStore.removeListener('HostedSuccessfully', this.hostedResponse);
        buttonAction = "";
        existingPDF = [];
        proceedCart = false;
    }
    /**
     * WW-920_PC_18 -Aparna
     * to get form data from db
     * */
    dynamicForms_API = () => {

        let dynamicFormBO = {
            formName: this.state.FormList[0].FormName.trim()
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        SupplierSuggestionAction.dynamicFormData(dynamicFormBO);
    }
    /**
     * WW-920_PC_19 -Aparna
     * dynamci form response method
     * */
    dynamicForms_API_response = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        
        let DynamicFormResData = JSON.parse(SupplierSuggestionStore.dynamicFormResponse);
        let FormDataDtArr = []
        let OptionsDataDtArr = []
        if (DynamicFormResData.ErrorMessageDT != null && DynamicFormResData.ErrorMessageDT != undefined) {
            
            if (DynamicFormResData.ErrorMessageDT.length > 0) {
                
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: DynamicFormResData.ErrorMessageDT[0].ErrorMessage
                });
                this.props.history.push({
                    pathname: "/shoppingcart",
                    // state: { item: AddToCartBO, qty: GridArray[index].QuantityOrdered, product: CookieService.getLocalStorageValues("EnersysFormVaue"), WO: WorkOrder, pagename: FromPageName, searchKey: SearchKey, form: CookieService.getLocalStorageValues("EnersysForm") }
                });
                return;
            }
        }
        else {
            if (DynamicFormResData.FormDataDt != null && DynamicFormResData.FormDataDt != undefined) {
                if (DynamicFormResData.FormDataDt.length > 0) {
                    FormDataDtArr = DynamicFormResData.FormDataDt
                }
                else {
                    this.props.history.push({
                        pathname: "/shoppingcart",
                    });
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "An external error occurred while fetching data"
                    });
                }

            } else {
                this.props.history.push({
                    pathname: "/shoppingcart",
                });
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "An external error occurred while fetching data"
                });
            }
            if (DynamicFormResData.OptionsDataDt != null && DynamicFormResData.OptionsDataDt != undefined) {
                if (DynamicFormResData.OptionsDataDt.length > 0) {
                    OptionsDataDtArr = DynamicFormResData.OptionsDataDt
                }
            }
        }

        this.setState({ FormData: FormDataDtArr, FormOptionsData: OptionsDataDtArr});
        this.optionsLoad()
    }
    AddToCart() {
        
        console.log('pagename', this.props.location.state.pagename);
        let quantity = this.props.location.state.qty;
        let quantityValid = quantity % 1;
        let filePaths = this.state.attachmentPathArr.map((value) => {
            return value.FilePath;
        });
        let filePathsString = filePaths.join('|');
        //Precart SIT 1 bug fix - Yuvarani K
        if (this.props.location.state.pagename == 'ItemDetail') {
            this.props.location.state.item.NonItemDetails[0].filePath = filePathsString; 
            this.props.location.state.item.NonItemDetails[0].RTI_QTY = quantity;
            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else if (this.props.location.state.pagename == 'SearchResult') {
            this.props.location.state.item.NonItemDetails[0].filePath = filePathsString;
            this.props.location.state.item.NonItemDetails[0].RTI_QTY = quantity;
            SearchResultsAction.AddCart(this.props.location.state.item)

        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please complete the form"
            });
        }
        
    }

    AddToCartResponse = () => {
        let AddCartResponse = JSON.parse(ItemDetailNewStore.addToCartList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let SuccessFlag = AddCartResponse.SuccessFLag;
        let Update_Session = AddCartResponse._FlagDt;
        if (SuccessFlag[0].Status == "true" || SuccessFlag[0].Status == "True") {
            if (Update_Session[0].dtCM != [] && Update_Session[0].dtCM != "") {
                CookieService.updateLocalStorageValues("Session_dtCM", Update_Session[0].dtCM);
            }
            if (Update_Session[0].Session_gotStock != null && Update_Session[0].Session_gotStock != "") {
                CookieService.updateLocalStorageValues("Session_gotStock", Update_Session[0].Session_gotStock);
            }
            if (Update_Session[0].Session_gotNSTK != null && Update_Session[0].Session_gotNSTK != "") {
                CookieService.updateLocalStorageValues("Session_gotNSTK", Update_Session[0].Session_gotNSTK);
            }
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
        else {
            if (Update_Session[0].Session_CARTFAIL != null && Update_Session[0].Session_CARTFAIL != "") {
                CookieService.updateLocalStorageValues("Session_CARTFAIL", Update_Session[0].Session_CARTFAIL);
            }
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Techincal Issue Contact SDI Customer Care"
            });

        }
    }
    loadAttachments = () => {
        
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            console.log("attachmentResponse", attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            //WW-920_PC_22 -Aparna
            if (this.props.location.state.pagename != "shoppingcart") {
                this.AddToCart();
            } else {
                this.ItemInCart()
            }


        } else {
            this.setState({
                attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
            });
        }
    };

    /**
     * WW-920_PC_21 -Aparna
     * to insert file in cart table
     * */
    ItemInCart = () => {
        // Step 1: Map FilePaths from attachmentPathArr
        let filePaths = this.state.attachmentPathArr.map((value) => value.FilePath);

        // Step 2: Concatenate with existingPDF
        let combinedFilePaths = existingPDF ? filePaths.concat(existingPDF) : filePaths;

        // Step 3: Join to form a single string with '|'
        let filePathsString = combinedFilePaths.join('|');

        let UpdateItemDetails = {
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT").trim(),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            fldToUpdate: "FILE_PATH",
            ItemID: this.state.FormList[0].SupplierPartNumber,
            LineNum: this.state.FormList[0].LineItem,
            newValue: filePathsString,
            IsMultipleColumn : true,
            FieldsList: [{ Field: "RTI_QTY", Value: Number(this.state.FormList[0].Qty) }, { Field: "FILE_PATH" , Value: filePathsString }]
        }
        ShoppingCartAction.UpdateItemDesp(UpdateItemDetails);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /**
     * WW-920_PC_23 -Aparna 
     * reponse method after inserting file path in the cart table to get the next form detail or to navigate to shoppingcart
     * */
    UpdateItemDesp_response = () => {
        let locFormList = this.state.FormList.splice(1);

        if (locFormList.length > 0) {
            this.dynamicForms_API()
            this.setState({ FormList: locFormList, FormOptionsData: [], FormData: [], formArray: [], formIndex: 0, currentQty: 0, totalQty: Number(locFormList[0].Qty) - Number(locFormList[0].RTI_QTY ? locFormList[0].RTI_QTY : 0), formCount:1 })
        }
        else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    }
    /**
     * WW-920_PC_24 -Aparna 
     * to delete item form cart
     * */
    DeleteItemFromCart = () => {
        let DeleteItemBO = {
            userID: CookieService.getLocalStorageValues("Session_UserID"),
            userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
            ItemID: this.state.FormList[0].SupplierPartNumber,
            LineNum: this.state.FormList[0].LineItem,
            DeleteFlag: true
        };
        ShoppingCartAction.DeleteCartItem(DeleteItemBO);
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }
    /**
     * WW-920_PC_25 -Aparna 
     * response method for delete item to get the next form detail or ot navigate to shoppingcart
     * */
    DeleteItemFromCart_response = () => {
        let deleteItemAry = JSON.parse(ShoppingCartStore.deleteItemAry);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (deleteItemAry != "" || deleteItemAry != null) {
            let locFormList = this.state.FormList.splice(1);
            //this.setState({ FormList: locFormList })
            if (locFormList.length > 0) {
                this.dynamicForms_API()
                this.setState({ FormList: locFormList, FormOptionsData: [], FormData: [], formArray: [], formIndex: 0, currentQty: 0, totalQty: Number(locFormList[0].Qty) - Number(locFormList[0].RTI_QTY ? locFormList[0].RTI_QTY : 0), formCount:1 })
            }
            else {
                this.props.history.push({
                    pathname: "/shoppingcart",
                });
            }
        }
        else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    }
    AddtocartSuccess = () => {
        const { t } = this.props
        let Status = JSON.parse(SearchResultsStore.SuccessStatus);
        let itemstatus = Status._FlagDt
        let iteminsertstatus = Status.SuccessFLag
        let PageLSearchResults = this.state.PageLoadSearchResults;
        let FilterdValue = this.state.FilteredSearchResults;
        if (itemstatus.length > 0) {
            if (itemstatus[0].is_Success == "True" || itemstatus[0].is_Success == "true") {

                let itemidnotinserted = ""
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."

                    });

                }
                this.props.history.push({
                    pathname: `\shoppingcart`,
                    search: `?SearchKey=${this.props.location.state.searchKey}`
                });

            }
            else {

                let itemidnotinserted = ""
                let validate = false;
                let formPopup = false;
                if (iteminsertstatus != null && iteminsertstatus != undefined && iteminsertstatus != "") {
                    iteminsertstatus.map((val, index) => {
                        if (val.Status != "true" && val.Session_CARTFAIL == "Forms Limit Reached") {
                            formPopup = true;
                            return true;
                        }
                        else if (val.Status != "true") {
                            if (itemidnotinserted != "") {
                                itemidnotinserted = itemidnotinserted + "," + val.ItemId
                            }
                            else {
                                itemidnotinserted = itemidnotinserted + val.ItemId
                            }
                        }
                        else if (validate != true && val.Status == "true") {
                            validate = true
                        }
                    });
                }
                if (itemidnotinserted != null && itemidnotinserted != undefined && itemidnotinserted != "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Item " + itemidnotinserted + " is not added to cart due to technical issue. Contact SDI customer care."

                    });
                }
                if (formPopup) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("This item is already in the cart and has reached the maximum number of 10 forms")

                    });
                }
                if (validate == true) {
                    this.props.history.push({
                        pathname: `\shoppingcart`,
                        search: `?SearchKey=${this.props.location.state.searchKey}`
                    });


                }
                else if (itemidnotinserted == null || itemidnotinserted == undefined || itemidnotinserted == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Techincal Issue Contact SDI Customer Care"

                    });
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
                else {
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                }
            }
        }

    }
    keyPress(e, index) {
        const invalidChars = ["-", "+", "e",];
        if (invalidChars.includes(e.key)) e.preventDefault();
        let FormData = [...this.state.FormData];
        if (FormData[index].TYPE.toUpperCase() == "NUMBER") {
            if (FormData[index].MAXNUMBER != null && FormData[index].MAXNUMBER != undefined) {
                if (FormData[index].TEXT == FormData[index].MAXNUMBER) {
                    if (e.key == ".") {
                        e.preventDefault();
                    }
                }
            }
        }
    };

    handleAttachment = (blobArray) => {
        let files = [];
        blobArray.forEach((b, index) => {
            const file = new File([b], `${this.state.FormName} - Form.pdf`);
            files.push(file);
        });
        if (this.props.location.state.pagename != "shoppingcart") {
            if (files.length > 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Item Successfully Added To Cart"
                });
            }
        }
        NonCatalogAction.FormsaddAttachment(files);
        //  $(`#${SDIConstants.SDILoader}`).addClass('hide');     

    }
    optionsLoad = () => {
        let FormOptionsDataArr = [];
        if (this.state.FormOptionsData != null && this.state.FormOptionsData != undefined) {
            FormOptionsDataArr = this.state.FormOptionsData;
            FormOptionsDataArr.forEach((value, index) => {
                value.OptionSelect = false;
            });
        }
        let FormDataArr = [];
        if (this.state.FormData != null && this.state.FormData != undefined) {
            FormDataArr = this.state.FormData;
            FormDataArr.forEach((value, index) => {
                value.ONCHANGETEXT = "";
                value.TEXT = "";
                if (value.PREFILLTEXT != "" && value.PREFILLTEXT != null && value.PREFILLTEXT != undefined) {
                    if (value.QUESTIONS.trim() == "Install store" && value.TYPE.toUpperCase() === "TEXT") {
                        const storeValue = localStorage.getItem("StoreValue") ? JSON.parse(localStorage.getItem("StoreValue")) : "";
                        const isBlanketWO = CookieService.getLocalStorageValues("IsBlanketWO");
                        value.ONCHANGETEXT = localStorage.getItem("WONum") && storeValue === isBlanketWO
                            ? ""
                            : (localStorage.getItem("WONum") && storeValue ? storeValue : "");
                        value.PREFILLTEXT = localStorage.getItem("WONum") && storeValue === isBlanketWO
                            ? value.PREFILLTEXT
                            : (localStorage.getItem("WONum") && storeValue ? "" : value.PREFILLTEXT);
                    }
                    value.TEXT = String(value.PREFILLTEXT || "") + String(value.ONCHANGETEXT || "");
                    value.TEXTCOUNT = (String(value.PREFILLTEXT || "") + String(value.ONCHANGETEXT || "")).length;
                }
                else if (value.TYPE.toUpperCase() === "TEXT") {
                    switch (value.QUESTIONS.trim()) {
                        case "Technician name":
                            value.ONCHANGETEXT = `${CookieService.getLocalStorageValues("Session_LASTNAME")}, ${CookieService.getLocalStorageValues("Session_FIRSTNAME")}`;
                            break;
                        case "Technician phone number":
                            value.ONCHANGETEXT = CookieService.getLocalStorageValues("Session_PHONE");
                            break;
                        case "Technician email address":
                            value.ONCHANGETEXT = CookieService.getLocalStorageValues("Session_EMAIL");
                            break;
                        case "Work order number":
                            value.ONCHANGETEXT = localStorage.getItem("WONum") ? JSON.parse(localStorage.getItem("WONum")) : "";
                            break;
                        default:
                            break;
                    }
                    value.TEXT = String(value.ONCHANGETEXT || "");
                    value.TEXTCOUNT = String(value.ONCHANGETEXT || "").length;
                }
            });
        }
        this.setState({ FormOptionsData: FormOptionsDataArr, formDataTemp: JSON.parse(JSON.stringify(FormDataArr)), FormData: FormDataArr, attachmentPathArr : []});
    }


    handleFormChange = (e, value, index) => {
        let FormData = JSON.parse(JSON.stringify(this.state.FormData));
        let previousValue = FormData[index].TEXT;
        if (FormData[index].TYPE.toUpperCase() == "NUMBER") {
            if (FormData[index].MAXNUMBER != null && FormData[index].MAXNUMBER != undefined && FormData[index].MINNUMBER != null && FormData[index].MINNUMBER != undefined) {
                if (e.target.value >= FormData[index].MINNUMBER && e.target.value <= FormData[index].MAXNUMBER) {
                    if (parseInt(FormData[index].MINNUMBER) == 0 && e.target.value == "0") {
                        FormData[index].TEXT = e.target.value.replace(/^0+/, '');
                        FormData[index].TEXT = "0"
                    }
                    else {
                        FormData[index].TEXT = e.target.value.replace(/^0+/, '');
                    }

                    if (FormData[index].TEXT.includes(".")) {
                        let textLimit = FormData[index].TEXT.slice(0, (FormData[index].TEXT.indexOf(".")) + 4);
                        if (textLimit.split(".")[0] == "") {
                            FormData[index].TEXT = "0" + textLimit
                        }
                        else {
                            FormData[index].TEXT = textLimit
                        }
                    }

                }
                else {
                    if (e.target.value.trim() == "") {
                        FormData[index].TEXT = ""
                    }
                }
                //else { FormData[index].TEXT = "0" }

            }
            else {
                FormData[index].TEXT = e.target.value.replace(/^0+/, '');
                if (FormData[index].TEXT.includes(".")) {
                    let textLimit = FormData[index].TEXT.slice(0, (FormData[index].TEXT.indexOf(".")) + 4);
                    FormData[index].TEXT = textLimit
                }
            }
            if (FormData[index].QUESTIONS == "Quantity") {
                let formArray = JSON.parse(JSON.stringify(this.state.formArray));
                let currentQty = this.state.currentQty;
                let formIndex = this.state.formIndex;
                if (formArray && formArray.length > 0 && formIndex >= 0 && formIndex < formArray.length) {
                    currentQty = currentQty - parseInt(previousValue ? previousValue : 0 , 10);
                    currentQty = currentQty + parseInt(FormData[index].TEXT ? FormData[index].TEXT : 0, 10);
                    this.setState({ currentQty: currentQty });
                }
                else if (formIndex >= formArray.length) {
                    let qty = 0;
                    if (formArray.length > 0) {
                        qty = formArray.reduce((acc, value) => {
                            return acc + parseInt(value.formData[index]?.TEXT ? value.formData[index].TEXT : 0, 10);
                        }, 0);
                    }
                    currentQty = parseInt(FormData[index]?.TEXT ? FormData[index].TEXT : 0, 10) + qty ;
                    this.setState({ currentQty });
                }
            }
            
        }
        else if (FormData[index].TYPE.toUpperCase() == "TEXT" || FormData[index].TYPE.toUpperCase() == "TEXTAREA") {
            if (value.PREFILLTEXT == null && value.PREFILLTEXT == undefined) {
                if (e.target.value.trim() == "") {
                    FormData[index].ONCHANGETEXT = ""
                    FormData[index].TEXT = ""
                    FormData[index].TEXTCOUNT = 0
                }
                else {
                    FormData[index].ONCHANGETEXT = e.target.value
                    FormData[index].TEXT = e.target.value
                    FormData[index].TEXTCOUNT = FormData[index].TEXT.length
                }
            }
            else if (value.PREFILLTEXT.trim() != "") {
                if (e.target.value.trim() == value.PREFILLTEXT.trim()) {
                    FormData[index].ONCHANGETEXT = e.target.value.substring(FormData[index].PREFILLTEXT.length, e.target.value.trim().length)
                    FormData[index].TEXT = ""
                    FormData[index].TEXTCOUNT = value.PREFILLTEXT.length
                }
                else {
                    FormData[index].ONCHANGETEXT = e.target.value.substring(FormData[index].PREFILLTEXT.length, e.target.value.length)
                    FormData[index].TEXT = FormData[index].PREFILLTEXT + FormData[index].ONCHANGETEXT
                    FormData[index].TEXTCOUNT = FormData[index].TEXT.length
                }
            }
            else {
                if (e.target.value.trim() == "") {
                    FormData[index].ONCHANGETEXT = ""
                    FormData[index].TEXT = ""
                    FormData[index].TEXTCOUNT = 0
                }
                else {
                    FormData[index].ONCHANGETEXT = e.target.value
                    FormData[index].TEXT = e.target.value
                    FormData[index].TEXTCOUNT = FormData[index].TEXT.length
                }
            }

        }
        else if (FormData[index].TYPE.toUpperCase() === "ATTACHMENT") {
            let files = e.target.files;
            if (files && files.length > 0) {
                if (!e.target.files[0].name.toLowerCase().includes(".jpeg") && !e.target.files[0].name.toLowerCase().includes(".jpg") && !e.target.files[0].name.toLowerCase().includes(".png") && !e.target.files[0].name.toLowerCase().includes(".svg") && !e.target.files[0].name.toLowerCase().includes(".heic") && !e.target.files[0].name.toLowerCase().includes(".heif")
                ) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please upload files in supported formats such as JPG, SVG, JPEG, PNG, HEIC and HEIF "
                    });
                }
                else {
                    // Construct the new state array
                    let updatedAllowOneUpload = [...this.state.allowOneUpload];
                    updatedAllowOneUpload[index] = index;

                    // Set the state with the updated array
                    this.setState({ allowOneUpload: updatedAllowOneUpload, uploadIndex: index, uploadedByte: e.target.files[0] });


                    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                    NonCatalogAction.addAttachmentForms(e.target.files);
                }
            }
        }


        else {
            FormData[index].TEXT = e.target.value

        }

        this.setState({ FormData });
        console.log("handleGridChange", FormData);
    }

    onInputClick = (event) => {
        event.target.value = ''
    }

    uploadImageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            if (attachmentResponse && attachmentResponse.length > 0) {
                let tempAttachments = this.state.tempImageArr;
                let tempData = this.state.FormData;
                let reader = new FileReader();
                reader.onload = () => {
                    if (reader.result) {
                        let base64String;
                        if (typeof reader.result === 'string') {
                            base64String = reader.result.split(',')[1]; // Extract base64 string
                        } else {
                            base64String = this.arrayBufferToBase64(reader.result); // Convert ArrayBuffer to base64 using chunking
                        }
                        let obj = {
                            FileName: attachmentResponse[0].FileName,
                            FilePath: attachmentResponse[0].FilePath,
                            FileByte: base64String // Assign base64 string to FileByte
                        };
                        tempAttachments[this.state.uploadIndex] = obj;
                        tempData[this.state.uploadIndex].TEXT = attachmentResponse[0].FileName;
                        this.setState({ tempImageArr: tempAttachments, FormData: tempData });
                        console.log("tempAttachments", tempAttachments);
                    } else {
                        console.error("Error: FileReader result is null or undefined.");
                    }
                };
                reader.onerror = (error) => {
                    //console.error("FileReader error:", error);
                };
                reader.readAsArrayBuffer(this.state.uploadedByte);
            } else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "You have exceeded the length of total file names"
                });
            }
        }
    };

    arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i += 4096) { // Chunk the buffer into pieces
            const chunk = bytes.slice(i, i + 4096);
            binary += String.fromCharCode.apply(null, chunk);
        }
        return btoa(binary);
    }


    downloadImage = (e, index) => {
        e.preventDefault();
        let downloadBO = {
            fileName: this.state.tempImageArr[index].FileName,
            filePath: this.state.tempImageArr[index].FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };

    removeImage = (index) => {
        let removeBO = {
            filePath: this.state.tempImageArr[index].FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachmentForms(removeBO);
        this.setState({ uploadIndex: index })
    };

    removeAttachmentResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.tempImageArr;
            tempAttachments[this.state.uploadIndex] = "";
            let fakeuploadOne = this.state.allowOneUpload;
            fakeuploadOne[this.state.uploadIndex] = "";
            let tempData = this.state.FormData
            tempData[this.state.uploadIndex].TEXT = "";
            this.setState({ tempImageArr: tempAttachments, allowOneUpload: fakeuploadOne, FormData: tempData });

        }
    }

    hostedResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let hostedResponse = JSON.parse(ShoppingCartStore.hostedResponse);
        if (hostedResponse == "File not hosted") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Error in hosting the files, please try again later"
            });
        }
        else if (hostedResponse == "Invalid data") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid data, please enter image of correct format"
            });
        }
        else if (hostedResponse == "Server Error") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Server error, please try again later"
            });
        }
        else {
            let FormData = JSON.parse(JSON.stringify(this.state.FormData));
            hostedResponse.forEach((item, index) => {
                FormData[item.QuestionNo].TEXT = item.FileURL;
                this.setState({ FormData: FormData });
            });
            let formIndex = this.state.formIndex;
            let formArray = JSON.parse(JSON.stringify(this.state.formArray));
            let tempImageArr = JSON.parse(JSON.stringify(this.state.tempImageArr));
            let allowOneUpload = JSON.parse(JSON.stringify(this.state.allowOneUpload));
            let formCount = this.state.formCount;
            if (formIndex < formArray.length) {
                if (buttonAction == "next") {
                    formArray[formIndex].formData = FormData;
                    formArray[formIndex].tempImageArr = tempImageArr; 
                    formArray[formIndex].allowOneUpload = allowOneUpload
                    if (formArray[formIndex + 1]) {
                        FormData = formArray[formIndex + 1].formData;
                        tempImageArr = formArray[formIndex + 1].tempImageArr;
                        allowOneUpload = formArray[formIndex + 1].allowOneUpload;

                        formIndex = formIndex + 1;
                    }
                    else if (formIndex < 9) {
                        formCount++;
                        tempImageArr = [];
                        FormData = JSON.parse(JSON.stringify(this.state.formDataTemp));
                        formIndex = formIndex + 1;
                        allowOneUpload = [];
                    }
                }
                else {
                    formArray[formIndex].formData = FormData;
                    formArray[formIndex].tempImageArr = tempImageArr;
                    formArray[formIndex].allowOneUpload = allowOneUpload
                    tempImageArr = formArray[formIndex - 1].tempImageArr;
                    FormData = formArray[formIndex - 1].formData;
                    allowOneUpload = formArray[formIndex - 1].allowOneUpload;
                    formIndex = formIndex - 1;
                }
            }
            else if (formIndex == formArray.length) {
                formArray.push({ formData: FormData, tempImageArr: this.state.tempImageArr, allowOneUpload: allowOneUpload });
                if (buttonAction == "next") {
                    formCount++;
                    tempImageArr = [];
                    FormData = JSON.parse(JSON.stringify(this.state.formDataTemp));
                    formIndex = formIndex + 1;
                    allowOneUpload = [];
                }
                else {
                    tempImageArr = formArray[formIndex - 1].tempImageArr;
                    FormData = formArray[formIndex - 1].formData;
                    allowOneUpload = formArray[formIndex - 1].allowOneUpload;
                    formIndex = formIndex - 1;
                }
            }
            this.setState({ tempImageArr: tempImageArr, FormData: FormData, formIndex: formIndex, formArray: formArray, allowOneUpload: allowOneUpload, formCount: formCount });
            if (buttonAction!= 'previous' && proceedCart) {
                this.generatePDF(formArray);
            } 
        }
    }

    handleOptionsChange = (e, OPTIONS, OPTIONNO, QUESTIONNO) => {
        
        let ind = this.state.FormOptionsData.findIndex(x => x.OPTIONS == OPTIONS && x.OPTIONNO == OPTIONNO && x.QUESTIONNO == QUESTIONNO)
        let SelectedOptions = []
        let SelectedOptionsList = []
        let SelectedFormDataInd
        let FormOptionsData = [...this.state.FormOptionsData];
        let FormData = [...this.state.FormData];
        if (e.currentTarget.checked == true || e.currentTarget.checked == false) {
            FormOptionsData[ind].OptionSelect = e.currentTarget.checked
            SelectedOptions = FormOptionsData.filter((x) => x.QUESTIONNO == QUESTIONNO && x.OptionSelect == true)
            SelectedFormDataInd = FormData.findIndex((x) => x.QUESTIONNO == QUESTIONNO)
            if (SelectedOptions.length > 0) {

                SelectedOptions.forEach((value, index) => {

                    SelectedOptionsList.push(value.OPTIONS)

                });

            }
            if (SelectedOptionsList != null && SelectedOptionsList != undefined && SelectedOptionsList.length != 0) {
                FormData[SelectedFormDataInd].TEXT = SelectedOptionsList.join(",")
            }
            else {
                FormData[SelectedFormDataInd].TEXT = ""
            }

            this.setState({ FormOptionsData, FormData });
            console.log("FormOptionsDataHandle", FormOptionsData)
            console.log("FormDataHandle", FormData)
        }
    }


    renderDropdown(QUESTIONNO) {
        return this.state.FormOptionsData.map((FormOptionsValue, FormOptionsIndex) => {
            if (FormOptionsValue.QUESTIONNO == QUESTIONNO) {
                return (<option key={FormOptionsValue.OPTIONS} value={FormOptionsValue.OPTIONS} > {FormOptionsValue.OPTIONS}</option>)
            }
        });

    }
    renderRadioBtn(QUESTIONNO, TEXT) {
        return this.state.FormOptionsData.map((FormOptionsValue, FormOptionsIndex) => {
            if (FormOptionsValue.QUESTIONNO == QUESTIONNO) {
                //Bug-5483 -Vishwa S
                return (
                    <div key={FormOptionsIndex}>
                        <label htmlFor={`${FormOptionsValue.QUESTIONNO}-${FormOptionsIndex}`} className="w-100">
                            <input type="radio" id={`${FormOptionsValue.QUESTIONNO}-${FormOptionsIndex}`} name={FormOptionsValue.QUESTIONNO} value={FormOptionsValue.OPTIONS} checked={TEXT === FormOptionsValue.OPTIONS} className="mr-1" />
                            {FormOptionsValue.OPTIONS}
                        </label>
                    </div>
                )

            }
        });

    }

    renderCheckBox(QUESTIONNO) {
        return this.state.FormOptionsData.map((FormOptionsValue, FormOptionsIndex) => {
            if (FormOptionsValue.QUESTIONNO == QUESTIONNO) {
                return (<div className="custom-Formcontrol custom-checkbox item-custom-control mt-1 mr-1 w-100">
                    <input type="checkbox" class="custom-control-input" ref="formText" id={`option-${FormOptionsValue.QUESTIONNO}${FormOptionsValue.OPTIONS}`} name={QUESTIONNO} checked={FormOptionsValue.OptionSelect == true} onChange={(e) => this.handleOptionsChange(e, FormOptionsValue.OPTIONS, FormOptionsValue.OPTIONNO, FormOptionsValue.QUESTIONNO)} />
                    <label class="custom-control-label" htmlFor={`option-${FormOptionsValue.QUESTIONNO}${FormOptionsValue.OPTIONS}`}>{FormOptionsValue.OPTIONS}</label>
                </div>)

            }
        });

    }

    madatoryFieldCheck = () => {
        const { t } = this.props
        console.log("FormDataCon", this.props.location.state.FormData);
        console.log("FormOptionsDataCon", this.state.FormOptionsData);
        let MandatoryData = []
        let prefillTxtCheck = []
        let intReturn = 0
        let FormDataValues = []
        if (this.state.FormData != null && this.state.FormData != undefined) {
            MandatoryData = this.state.FormData.filter((x) => x.MANDATORY != "N")
        }

        if (MandatoryData.length > 0) {
            MandatoryData.forEach((value, index) => {
                if (value.PREFILLTEXT != undefined && value.PREFILLTEXT != null && value.PREFILLTEXT != "") {
                    if (value.TEXTCOUNT == value.PREFILLTEXT.length) {
                        prefillTxtCheck.push(value)
                    }
                    else {
                        prefillTxtCheck = []
                    }
                }

                if (prefillTxtCheck.length != 0) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: t("Please fill all the mandatory fields")
                    });
                    intReturn += 1
                }
                else {
                    if (value.TEXT.trim() == "" || value.TEXT == null || value.TEXT == undefined) {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: t("Please fill all the mandatory fields")
                        });
                        intReturn += 1

                    }
                }
            });

        }
        else {
            return true;
        }
        if (intReturn > 0) {
            return false
        }
        else {
            return true
        }

    }

    hostimage = (status) => {
        const {t}=this.props
        buttonAction = status;
        let hostBo = []; 
        let FormData = JSON.parse(JSON.stringify(this.state.FormData));
        let formIndex = this.state.formIndex;
        let formArray = JSON.parse(JSON.stringify(this.state.formArray));
        let tempImageArr = JSON.parse(JSON.stringify(this.state.tempImageArr));
        let allowOneUpload = JSON.parse(JSON.stringify(this.state.allowOneUpload));
        let formCount = this.state.formCount;
        if (this.props.location.state.pagename == "shoppingcart" && this.state.FormList && this.state.FormList[0].SupplierPartNumber) {
            let CartStorage = JSON.parse(localStorage.getItem("CartStorage"));
            let itemInCart = CartStorage.filter(item => item.Itemid === this.state.FormList[0].SupplierPartNumber);
            existingPDF = itemInCart[0].FilePath;
            if (status == "next" && (itemInCart[0].FilePath ? itemInCart[0].FilePath.length : 0) + formIndex + 1 >= 10 && !proceedCart) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "This item is already in the cart and has reached the maximum number of forms"
                });
                return true;
            }

        }
        if (this.props.location.state.pagename !== "shoppingcart" && buttonAction != "previous" && formIndex >= 9 && !proceedCart) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("The maximum number of forms has been reached. Please adjust the quantity or place a separate order.")
            });
            return true;
        }
        else if (status == "next" && this.state.currentQty > Number(this.state.totalQty) && proceedCart) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("The entered quantity does not match the requested quantity")
            });
            return true;
        }
        if (this.state.tempImageArr && this.state.tempImageArr.length == 0) {
            if (formIndex < formArray.length) {
                if (status == "next") {
                    formArray[formIndex].formData = FormData;
                    formArray[formIndex].tempImageArr = tempImageArr;
                    formArray[formIndex].allowOneUpload = allowOneUpload
                    if (formArray[formIndex + 1]) {
                        FormData = formArray[formIndex + 1].formData;
                        tempImageArr = formArray[formIndex + 1].tempImageArr;
                        allowOneUpload = formArray[formIndex + 1].allowOneUpload;
                        formIndex = formIndex + 1;
                    }
                    else if (formIndex < 9) {
                        formCount++;
                        tempImageArr = [];
                        FormData = JSON.parse(JSON.stringify(this.state.formDataTemp));
                        formIndex = formIndex + 1;
                        allowOneUpload = [];
                    }
                    
                }
                else {
                    formArray[formIndex].formData = FormData;
                    formArray[formIndex].tempImageArr = tempImageArr;
                    formArray[formIndex].allowOneUpload = allowOneUpload
                    tempImageArr = formArray[formIndex - 1].tempImageArr;
                    FormData = formArray[formIndex - 1].formData;
                    allowOneUpload = formArray[formIndex - 1].allowOneUpload;
                    formIndex = formIndex - 1; 
                }
            }
            else if (formIndex == formArray.length) {               
                formArray.push({ formData: FormData, tempImageArr: this.state.tempImageArr, allowOneUpload: allowOneUpload });
                if (status == "next") {
                    formCount++;
                    tempImageArr = [];
                    FormData = JSON.parse(JSON.stringify(this.state.formDataTemp));
                    formIndex = formIndex + 1;
                    allowOneUpload = [];
                }
                else {
                    tempImageArr = formArray[formIndex - 1].tempImageArr;
                    FormData = formArray[formIndex - 1].formData;
                    allowOneUpload = formArray[formIndex - 1].allowOneUpload;
                    formIndex = formIndex - 1;
                }
             }
            this.setState({ tempImageArr: tempImageArr, FormData: FormData, formIndex: formIndex, formArray: formArray, allowOneUpload: allowOneUpload, formCount: formCount });
            
            if (buttonAction != 'previous' && proceedCart) {
                this.generatePDF(formArray);
            }   
        }
        else {

            this.state.tempImageArr.map((value, index) => {
                if (value != undefined && value != null && value != "") {
                    let obj = {
                        QuestionNo: index,
                        QuestionName: this.state.FormData[index].QUESTIONS,
                        FileName: value.FileName,
                        FileByte: value.FileByte,
                        FileURL: "",
                        UserID: CookieService.getLocalStorageValues("Session_UserID"),
                        UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT")
                    }
                    hostBo.push(obj)
                }
            })
            ShoppingCartAction.HostMultipleImages(hostBo);
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
    }



    generatePDF = async (formArray) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let blobArray = [];
        for (const [index, value] of formArray.entries()) {
            // Create a new document for each iteration
            const doc = (
                <FormsPDFComponent FormData={value.formData} />
            );
            const asPdf = pdf([]);
            asPdf.updateContainer(doc);
            const blob = await asPdf.toBlob();
            // Use a unique filename for each PDF
            saveAs(blob, `${value.formData[0].FORMNAME} - Form ${index + 1}.pdf`);
            blobArray.push(blob);
        }
        this.handleAttachment(blobArray);
    };

    bindURL(ADDITIONALINFO) {
        let rex = SDIConstants.urlregexp;
        let additionalinfoStr = ADDITIONALINFO.split(' ');
        return additionalinfoStr.map((value) => {
            if (!rex.test(value)) {
                return (<label>{value}&nbsp;</label>)
            }
            else {
                return (<a href={value} target="_blank">{value}&nbsp;</a>)
            }

        })
    }
    onImagePopUpClick = (e, FormDataValue) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (FormDataValue.ATTACHMENT == "\\N" || FormDataValue.ATTACHMENT == "") {
            FormDataValue.ATTACHMENT = "Images/noimage_new.png"
        }
        this.setState({ formAttachURL: FormDataValue.ATTACHMENT, formAttachLabel: FormDataValue.ATTACHMENT_LABEL, formAttachDesc: FormDataValue.ATTACHMENT_DESC });

        $('#Attachment').modal('show');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    };
    renderSwitch(FormData) {
        return FormData.map((FormDataValue, FormDataIndex) => {
            
            switch (FormDataValue.TYPE.toUpperCase()) {
                case 'TEXT':
                    return (
                        <div className="row mb-4">

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="float-left col-md-6 form-label catalog-label" style={{ wordBreak: "break-all" }}>{FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span>
                                        : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label> :
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}

                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}


                            <div className="col-md-6">
                                {FormDataValue.PREFILLTEXT == "" || FormDataValue.PREFILLTEXT == " " || FormDataValue.PREFILLTEXT == null || FormDataValue.PREFILLTEXT == undefined ? <input type="text" className="form-control w-100" maxLength={FormDataValue.MAXLENGTH} placeholder={FormDataValue.PLACEHOLDERTEXT} name={FormDataValue.QUESTIONNO} id={FormDataValue.QUESTIONNO}
                                    value={FormDataValue.ONCHANGETEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)}
                                /> :
                                    <input type="text" className="form-control W-100" ref="formText" maxLength={FormDataValue.MAXLENGTH} placeholder={FormDataValue.PLACEHOLDERTEXT} name={FormDataValue.QUESTIONNO} id={FormDataValue.QUESTIONNO}
                                        value={FormDataValue.PREFILLTEXT + FormDataValue.ONCHANGETEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)}
                                    />
                                }

                                {FormDataValue.MAXLENGTH == "" || FormDataValue.MAXLENGTH == " " || FormDataValue.MAXLENGTH == null || FormDataValue.MAXLENGTH == undefined ?
                                    <span className="formCount mt-2">{FormDataValue.TEXTCOUNT}/254</span> : <span className="formCount">{FormDataValue.TEXTCOUNT}/{FormDataValue.MAXLENGTH}</span>}
                            </div>


                        </div>


                    );
                case 'TEXTAREA':
                    return (

                        <div className="row mb-4">

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="float-left col-md-6 form-label catalog-label" >FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}

                                </label> :
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}


                            {FormDataValue.PREFILLTEXT == "" || FormDataValue.PREFILLTEXT == " " || FormDataValue.PREFILLTEXT == null || FormDataValue.PREFILLTEXT == undefined ?
                                <textarea className="form-control w-100" id={FormDataValue.QUESTIONNO} maxLength={FormDataValue.MAXLENGTH == "" || FormDataValue.MAXLENGTH == " " || FormDataValue.MAXLENGTH == null || FormDataValue.MAXLENGTH == undefined ? "254" : FormDataValue.MAXLENGTH} rows={5} placeholder={FormDataValue.PLACEHOLDERTEXT} name={FormDataValue.QUESTIONNO} value={FormDataValue.ONCHANGETEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)} /> :
                                <textarea className="form-control w-100" id={FormDataValue.QUESTIONNO} maxLength={FormDataValue.MAXLENGTH == "" || FormDataValue.MAXLENGTH == " " || FormDataValue.MAXLENGTH == null || FormDataValue.MAXLENGTH == undefined ? "254" : FormDataValue.MAXLENGTH} rows={5} placeholder={FormDataValue.PLACEHOLDERTEXT} name={FormDataValue.QUESTIONNO} value={FormDataValue.PREFILLTEXT + FormDataValue.ONCHANGETEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)} />
                            }

                            {FormDataValue.MAXLENGTH == "" || FormDataValue.MAXLENGTH == " " || FormDataValue.MAXLENGTH == null || FormDataValue.MAXLENGTH == undefined ?
                                <span className="formCount">{FormDataValue.TEXTCOUNT}/254</span> : <span className="formCount">{FormDataValue.TEXTCOUNT}/{FormDataValue.MAXLENGTH}</span>}
                        </div>


                    );
                case 'DROPDOWN':
                    return (
                        <div className="row mb-4" >

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}

                                </label> :
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}
                            <div className="col-md-6">
                                <select id={FormDataValue.QUESTIONNO} className="form-control w-100" value={FormDataValue.TEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)}>
                                    <option value="">{"Select"}</option>
                                    {this.renderDropdown(FormDataValue.QUESTIONNO)}
                                </select>
                            </div>

                        </div>
                    );
                case 'CHOICE':
                    return (
                        <div className="row mb-4" >

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="col-md-6 form-label catalog-label mb-2">{FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}

                                </label> :
                                <label className="col-md-6 form-label catalog-label mb-2">{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}

                            <label className="marginFormRadioBtn" onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)}>

                                {this.renderRadioBtn(FormDataValue.QUESTIONNO, FormDataValue.TEXT)}


                            </label>
                        </div>



                    );
                case 'CHECK':
                    return (
                        <div className="row mb-4" >

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}

                                </label> :
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}

                            <label className="form-label mt-2 ml-4 marginFormCheckBox">
                                {this.renderCheckBox(FormDataValue.QUESTIONNO)}
                            </label>

                        </div>

                    );
                case 'NUMBER':
                    return (
                        <div className="row mb-4">

                            {FormDataValue.MANDATORY == "Y" ?
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    <span className="mandatory-after float-left"></span>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}

                                </label> :
                                <label className="float-left col-md-6 form-label catalog-label" >{FormDataValue.QUESTIONS}
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                </label>}
                            <div className="col-md-6"> 
                                <input type="number" ref="formText" className="form-control w-100" min={FormDataValue.MINNUMBER} max={FormDataValue.MAXNUMBER} value={FormDataValue.TEXT} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)} onKeyDown={(e) => this.keyPress(e, FormDataIndex)} />
                            </div>
                        </div>
                    );
                case 'ATTACHMENT':
                    return (
                        <div className="row mb-4">

                            {FormDataValue.MANDATORY == "Y" ?
                                <div className="col-md-6 ">
                                    <label className="form-label catalog-label">{FormDataValue.QUESTIONS}<span className="mandatory-after"></span></label>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span>
                                        : null}
                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                    <label className="form-label font-regular font-14 w-100 mt-1">Only 1 image can be uploaded, adding another will replace it</label>
                                </div> :
                                <div className="col-md-6 ">
                                    <label className="form-label catalog-label">{FormDataValue.QUESTIONS}</label>
                                    {FormDataValue.ADDITIONALINFO != "" && FormDataValue.ADDITIONALINFO != " " && FormDataValue.ADDITIONALINFO != null && FormDataValue.ADDITIONALINFO != undefined ?
                                        <span className="info-container info-container-form ml-2">
                                            <img className="mb-1" src="Images/info-icon.png" />
                                            <span className="ml-2 info-content info-formposition">
                                                {this.bindURL(FormDataValue.ADDITIONALINFO)}
                                            </span>
                                        </span> : null}

                                    {FormDataValue.ATTACHMENT != "" && FormDataValue.ATTACHMENT != " " && FormDataValue.ATTACHMENT != null && FormDataValue.ATTACHMENT != undefined ?
                                        <p className="float-left col-md-12 p-0 helptext my-2">
                                            <a href className="helptext-link mr-1" style={{ "color": "#4995f2", "textDecoration": "underline", "cursor": "pointer" }} onClick={(e) => this.onImagePopUpClick(e, FormDataValue)}>Click Here</a>
                                            <span style={{ "color": "Grey" }}>for more information</span></p>
                                        : null}
                                    <label className="form-label font-regular font-14 w-100 mt-1">Only 1 image can be uploaded, adding another will replace it</label>
                                </div>}




                            <div class="col-md-6">
                                <div className="browse-btn">
                                    <button type="button" for={FormDataValue.QUESTIONNO} className="font-medium font-14 btn btn-primary custom-btn-primary primary-btn"><img src="images/upload-icon.svg" alt="upload" className="mr-1" /> Upload</button>
                                    <input type="file" className="reduce-input" accept="image/jpeg, image/jpg, image/png, image/svg+xml, image/heic, image/heif" name={FormDataValue.QUESTIONNO} id={FormDataValue.QUESTIONNO} onChange={(e) => this.handleFormChange(e, FormDataValue, FormDataIndex)} onClick={this.onInputClick} />
                                    <span hidden={!this.state.allowOneUpload.includes(FormDataIndex)}>
                                        <a href="#" className="noncat-Attachment-overflow ml-2" data-toggle="tooltip" onClick={(e) => this.downloadImage(e, FormDataIndex)}>{this.state.tempImageArr[FormDataIndex] != undefined && this.state.tempImageArr[FormDataIndex] != null && this.state.tempImageArr[FormDataIndex] != "" ? this.state.tempImageArr[FormDataIndex].FileName.length > 15 ? this.state.tempImageArr[FormDataIndex].FileName.slice(0, 15) + "..." : this.state.tempImageArr[FormDataIndex].FileName : ""}</a>
                                        <span className="attachment-remove-icon ml-1" onClick={() => this.removeImage(FormDataIndex)}>X</span>
                                    </span>
                                </div>
                            </div>


                        </div>


                    );
                default:
                    return '';
            }
        });

    }



    render() {
        return (

            <div className="container-fluid content-section">
                

                    <div className="row px-4">
                        <div className="col-md-12 mt-3 px-4 page-heading p-0">
                            <h5 className="page-title" id="heading">{this.state.FormData[0] != undefined && this.state.FormData[0] != null ? this.state.FormData[0].FORMNAME.toUpperCase() : ""} FORM</h5>
                        </div>
                    </div>
                    <div className="row mt-4 px-4">
                        <div className="col-md-7 mx-auto p-0">
                            <div className="form-info-box">
                            <p className="m-0 font-14 font-medium"><img src="images/form-info-icon.svg" alt="tooltip-icon-yellow" className="mr-2" />
                                <Trans>A maximum of 10 forms can be included per item.</Trans></p>
                            </div>
                            <div className="w-100 d-flex justify-content-between align-items-center form-quantity-filled-section px-2 mb-4">
                            <span className="font-20 font-medium black-color-text nowrap">Form {this.state.formIndex + 1}</span>
                            <span className="form-quantity-bar" />
                            <span className="form-quantity-parent black-color-text nowrap">
                                <span className="font-16 font-medium mr-2">
                                    {this.state.currentQty}/{this.state.totalQty}
                                </span>
                                <span className="font-12 font-regular"><Trans>Quantity filled</Trans></span>
                            </span>
                            </div>
                            {/* Buttons */}

                            {this.props.location.state.pagename == "shoppingcart" ?
                            <div className="col-md-12 mb-4 mt-3">
                                    <div className="row">
                                        <label id="Itemid_head" className="float-left col-md-6 form-label catalog-label pl-1" >Supplier part no</label>
                                        <label id="Itemid_head2" className="float-left col-md-6 form-label catalog-label">{this.state.FormList[0].SupplierPartNumber}</label>
                                    </div>
                                </div> : null}
                            <div className="col-md-12 page-heading my-3 m-0 p-0">
                                {this.renderSwitch(this.state.FormData)}
                                
                            </div>
                            <div className="d-flex justify-content-between py-5 my-5 sm-flex-column gap-3">
                                {this.state.formIndex != 0 ?
                                    <button className="btn prev-btn px-4 mr-3 sm-btn-full" onClick={
                                        async () => { this.hostimage("previous") }}>Previous</button> : null} 
                                <div className="d-flex ml-auto">
                                    {this.props.location.state.pagename == "shoppingcart" ?
                                        <button className="btn del-btn px-4 mr-3 primary-btn-responsive" onClick={() => this.DeleteItemFromCart()} >Delete item</button> : null}
                                    <button className="btn custom-btn-primary px-4 m-0 primary-btn-responsive"
                                        onClick={async () => {
                                            if (this.madatoryFieldCheck()) {
                                                if ((this.state.currentQty >= Number(this.state.totalQty) && this.state.formIndex + 1 == this.state.formCount)) {
                                                    proceedCart = true
                                                }
                                                else {
                                                    proceedCart = false
                                                }
                                                    this.hostimage("next")
                                            }
                                    }}>{this.props.location.state.pagename != "shoppingcart" && (this.state.currentQty >= Number(this.state.totalQty) && this.state.formIndex + 1 == this.state.formCount)  ? "Proceed to cart" : (this.props.location.state.pagename == "shoppingcart" && (this.state.currentQty >= Number(this.state.totalQty) && this.state.formIndex + 1 == this.state.formCount) ? "Update cart": "Next")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="modal pr-0" id="Attachment" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered modal-attach-style">
                            <div className="modal-content" style={{ "border": "0px" }}>
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1" />More Information<button type="button" className="btn close-btn" data-dismiss="modal">
                                        X</button></div>
                                {/* Modal body */}
                                {(this.state.formAttachLabel != "" && this.state.formAttachLabel != " " && this.state.formAttachLabel != undefined && this.state.formAttachLabel != null) || (this.state.formAttachDesc != "" && this.state.formAttachDesc != " " && this.state.formAttachDesc != undefined && this.state.formAttachDesc != null) ?
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <React.Fragment>
                                                    <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                                        <img src={this.state.formAttachURL} alt="binded-image" class="w-100" />
                                                    </MapInteractionCSS>
                                                </React.Fragment>
                                            </div>
                                            <div className="col-md-6">
                                                <h2 className="image-attach-label">{this.state.formAttachLabel}</h2>
                                                <p className="image-attach-para">{this.state.formAttachDesc}</p>
                                            </div>
                                        </div>
                                    </div> :
                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <React.Fragment>
                                                    <MapInteractionCSS minScale={1} maxScale={3.5} translationBounds={{ xMin: -1500, xMax: 60, yMin: -1250, yMax: 60 }} showControls >
                                                        <img src={this.state.formAttachURL} alt="binded-image" class="w-100" />
                                                    </MapInteractionCSS>
                                                </React.Fragment>
                                            </div>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>


            </div>

        );
    }
}

export default withTranslation()(FormsComponent);